export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9417.47dba4f6.jpg";